import { Box } from "@mui/material";
import { useState } from "react";
import { PhoneIcon, ShowPwIcon } from "../assets/icons/icons";
import AlertModal from "./alertModal";
import { AlertModalInput } from "./alertModalInput";
import usePostContactRecord from "../hooks/usePostContactRecord";
import { useI18n } from "../locales";
import { maskPhoneNumber } from "../utils/util";

type Props = {
  text: string;
  who: 1 | 2 | 3; // 소유자: 1, 추가 알림 수신자: 2, 사용자: 3
  userIdx: number | undefined;
  name: string; // 조회하려는 연락처의 주인 이름
  isMobile?: boolean; // 모바일 사이즈 여부
  justifyContent?: "center" | "space-between" | "flex-end"; // 텍스트 정렬
};

export const PhoneMaskToggle = ({
  text,
  who,
  userIdx,
  name,
  isMobile,
  justifyContent = "center",
}: Props) => {
  const { t } = useI18n();
  const [show, setShow] = useState(false); // 토글 상태 여부 (현재는 토글 구현 안됨. 한번 보여지면 끝)
  const [readerName, setReaderName] = useState(""); // 연락처 열람 조치자 이름
  const [openPhoneModal, setOpenPhoneModal] = useState(false);

  // 연락처 열람시 전달
  const { mutate: postContactRecord } = usePostContactRecord({
    who,
    reader_name: readerName,
    admin_idx: userIdx as number,
    showNum: () => setShow(true),
    showNokNum: () => {},
    closeModal: () => setOpenPhoneModal(false),
    phone: text,
    name: name, // 조회하려는 연락처의 주인 이름
  });

  const handleClick = () => {
    if (show) return;
    setOpenPhoneModal(true);
  };

  // 연락처 열람 모달에서 취소 클릭
  const onPressNoPhoneModal = () => {
    setOpenPhoneModal(false);
    setReaderName("");
  };

  // 연락처 열람 모달에서 열람하기 클릭
  const onPressYesPhoneModal = () => {
    postContactRecord();
  };

  if (!text) {
    return <div>{t.manageUser.noContact}</div>;
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: justifyContent,
          position: "relative",
          width: "100%",
          gap: "5px",
          cursor: show ? "default" : "pointer",
        }}
        component={`button`}
        onClick={handleClick}
      >
        {/* 데스크탑 사이즈 */}
        {!isMobile && <Box>{show ? text : maskPhoneNumber(text)}</Box>}
        {/* 모바일 사이즈 */}
        {isMobile && <Box>{show ? text : t.manageUser.viewContact}</Box>}
        {/* 토글 아이콘 */}
        {!show && <ShowPwIcon />}
      </Box>
      {/*  연락처 열람시 팝업되는 모달 */}
      {openPhoneModal && (
        <AlertModal
          open={openPhoneModal}
          onPressNo={onPressNoPhoneModal}
          title={t.manageUser.openContact}
          content={t.manageUser.protectingPrivacy}
          confirmText={t.manageUser.openContactButton}
          other={
            <AlertModalInput
              onChange={(e) => setReaderName(e.target.value)}
              placeholder={t.manageUser.enterOfficerName}
              value={readerName}
            />
          }
          onPressYes={onPressYesPhoneModal}
          icon={<PhoneIcon />}
          otherFilled={Boolean(readerName.length)}
        />
      )}
    </>
  );
};
